import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";

import { shouldShowField } from "../loanDetailEditUtil";

const DEFAULT_WIDTH = 138;

export const rows = {
  guaranteeType: {
    isVisible: data => shouldShowField(data, "recourse.guaranteeTypeId"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Recourse Type",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => {
          return defaultField(data, "recourse.recourseType.name")
        },
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.recourse.recourseTypeId"
      }
    ]
  },

  carveouts: {
    isVisible: data => shouldShowField(data, "recourse.carveouts"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Carveouts",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "recourse.carveouts"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.recourse.carveouts"
      }
    ]
  },
  guarantorCalculation: {
    isVisible: data => shouldShowField(data, "recourse.recourseCalculationMethod"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Guaranty Calculation Method",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "recourse.recourseCalculationMethod"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: " ",
        Cell: tableSideColumnMapper
      }
    ]
  },

  misc: {
    isVisible: data => shouldShowField(data, "recourse.misc"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "misc",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "recourse.misc"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.recourse.misc"
      }
    ]
  }
};
